<template>
    <div class="store-contact-order-form-page-1">
        <div class="form-group row mb-1">
            <label class="col-md-4 col-form-label" for="store">Magasin</label>
            <div class="col-md-4">
                <input type="text" class="form-control-plaintext" id="store" :value="selectedCustomer.name" readonly />
            </div>
        </div>

        <div class="form-group row">
            <div class="col-md-8 offset-md-4">
                <div class="delivery-days">
                    <strong>Jours de livraison :</strong> {{ selectedCustomer.delivery_days.join(', ') }}
                </div>
                <div>
                    <strong>Limite de commande :</strong>
                    {{ selectedCustomer.order_limit_day_numeric > 2 ? selectedCustomer.order_limit_day_label : selectedCustomer.order_limit_day_label + ' de' }} la livraison avant {{ selectedCustomer.order_limit_time_label }}
                    <i class="fas fa-info-circle cursor-help" v-on:click="displayInfos = true" style="color:#1e90ff"></i>
                </div>

                <div class="alert alert-dark text-center mt-2" v-if="displayInfos">
                    Nos produits sont fabriqués à la demande avec des ingrédients frais et locaux autant que possible.<br />
                    Pour chaque client nous déterminons le délai le plus court possible entre la date de commande et la livraison.<br />
                    Pour "{{ selectedCustomer.name }}", les commandes peuvent être passées jusqu'à
                    <strong>{{ selectedCustomer.order_limit_time_label }} {{ selectedCustomer.order_limit_day_numeric > 2 ? selectedCustomer.order_limit_day_label : selectedCustomer.order_limit_day_label + ' de' }} la livraison</strong>.
                </div>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 col-form-label" for="deliveryDate">Date de {{ isRecurrent ? 'la première ' : ''}}livraison</label>
            <template v-if="order">
                <div class="col-md-4" :class="{'offset-md-4': !order }">
                    <input type="text" class="form-control-plaintext" id="deliveryDateStatic" :value="formattedDeliveryDate()" readonly />
                    <div v-if="isRecurrent && deliveryDate">
                        <div class="alert alert-info">
                            Il s'agit de la date de la première livraison.<br>
                            Cette commande sera également automatiquement programmée pour une livraison tous les <span class="font-weight-bold text-underline">{{ deliveryDateDayName }}</span> suivants.<br>
                        </div>
                    </div>
                </div>
            </template>
            <StoreContactOrderFormCalendar
                v-else
                ref="deliveryDatepicker"
                id="deliveryDate"
                class="delivery-date col-lg-8 offset-lg-2 col-md-10 offset-md-1"
                :store="selectedCustomer"
                :order="order"
                :is-recurrent="isRecurrent"
                @dayclick="onDayClick"
            />
        </div>

        <warning-existing-orders-not-modified
            v-if="isRecurrent && deliveryDate"
            side="store_contacts"
            :editing="!!order"
            :customer="selectedCustomer"
            :delivery-date="deliveryDate.date"
            class="offset-md-2"
        >
        </warning-existing-orders-not-modified>

        <hr>

        <div class="row">
            <div class="col-12" :class="[!order ? 'text-center' : '']">
                <a v-if="backUrl" class="btn btn-outline-dark btn-quit" :href="backUrl">
                    <i class="fas fa-chevron-left"></i> Quitter la prise de commande
                </a>

                <button v-if="order" type="button" class="btn btn-success btn-next float-right" @click="onClickNext">
                    <i class="fas fa-chevron-right"></i> Suivant
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import WarningExistingOrdersNotModified from "../WarningExistingOrdersNotModified"
import StoreContactOrderFormCalendar from "./StoreContactOrderFormCalendar"
import {momentDay, momentDayName} from "../../moment-with-helpers"

export default {
    components: {
        StoreContactOrderFormCalendar,
        WarningExistingOrdersNotModified,
    },

    props: {
        selectedCustomer: {
            type: Object,
            required: true,
        },
        deliveryDate: {
            type: Object,
            required: false,
        },
        order: {
            type: Object,
            required: false,
        },
        isRecurrent: {
            type: Boolean,
            required: false,
            default: false,
        },
        backUrl: {
            type: String,
            required: false,
        },
    },

    data() {
        return {
            displayInfos: false,
        };
    },

    methods: {
        onClickNext() {
            this.onDayClick(this.deliveryDate);
        },

        onDayClick(date) {
            this.$emit('submit', {
                deliveryDate: date,
                selectedCustomer: this.selectedCustomer,
            });
        },

        formattedDeliveryDate() {
            if (this.deliveryDate) {
                return momentDay(this.deliveryDate.date).format('dddd Do MMMM YYYY');
            }
        },
    },

    computed: {
        deliveryDateDayName() {
            if (this.deliveryDate) {
                return momentDayName(this.deliveryDate.date);
            }
        },
    },
}
</script>
